import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import { getVendorName } from "../../../utils/getVendorName";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useFetchAllUserPointSummaryBorosilMutation } from "../../../features/tenant/Borosil/SalesBoosterHistoryBorosilApi";
import toast from "react-hot-toast";
import { formatter } from "../../../utils/numberFormatter";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";

function getToolTipMessage(type) {
    const tooltipMap = new Map([
        [
            "Points Earned",
            "This is the sum of total_points from monthly wallets for the selected financial year (month + year range).",
        ],
        [
            "Extra Points",
            "This is the sum of extra points for the selected financial year (excluding sales booster and sales booster redeemed types).",
        ],
        [
            "Total Points",
            "This is Points Earned + Extra Points combined.",
        ],
    ]);

    return tooltipMap.get(type) || "";
}

const UsersPointSummary = () => {
    const [
        fetchBorosilPointsSummary,
        {
            data: borosilPointSummaryData,
            isLoading: borosilPointSummaryIsLoading,
            error: borosilPointSUmmaryError,
        },
    ] = useFetchAllUserPointSummaryBorosilMutation();

    const [
        fetchBorosilPointsSummaryCsv,
        {
            data: borosilPointSummaryCsvData,
            isLoading: borosilPointSummaryCsvIsLoading,
            error: borosilPointSUmmaryCsvError,
        },
    ] = useFetchAllUserPointSummaryBorosilMutation();

    const navigate = useNavigate();

    const [totalRows, setTotalRows] = useState(0);
    const [data, setData] = useState([]);

    const [viewPointsSummaryToggle, setViewPointsSummaryToggle] =
        useState(false);
    const [pointsData, setPointsData] = useState(null);

    const [csvData, setCsvData] = useState(null);

    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);

    const initialRequest = {
        mobile: "",
        startDate: "",
        endDate: "",
        startMonth: null,
        startYear: null,
        endMonth: null,
        endYear: null,
        limit: limit,
        offset: offset,
    };

    const [request, setRequest] = useState(initialRequest);

    const clearFilters = () => {
        setRequest(initialRequest);
    };

    const fetchAllPointsSummaryFunc = () => {
        const { startDate, endDate, ...rest } = request;

        let updatedRequest = { ...rest };

        if (startDate) {
            const [year, month] = startDate.split("-");
            updatedRequest.startYear = year;
            updatedRequest.startMonth = month;
        }

        if (endDate) {
            const [year, month] = endDate.split("-");
            updatedRequest.endYear = year;
            updatedRequest.endMonth = month;
        }

        const queryParams = new URLSearchParams(updatedRequest).toString();

        fetchBorosilPointsSummary({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            queryParams: queryParams,
        });
    };

    const handlefetchAllPointsSummaryCsvFunc = () => {
        const { startDate, endDate, ...rest } = request;

        let updatedRequest = { ...rest };

        if (startDate) {
            const [year, month] = startDate.split("-");
            updatedRequest.startYear = year;
            updatedRequest.startMonth = month;
        }

        if (endDate) {
            const [year, month] = endDate.split("-");
            updatedRequest.endYear = year;
            updatedRequest.endMonth = month;
        }

        updatedRequest.limit = 10000;
        updatedRequest.offset = 0;

        const queryParams = new URLSearchParams(updatedRequest).toString();

        fetchBorosilPointsSummaryCsv({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            queryParams: queryParams,
        });
    };

    useEffect(() => {
        // if (JSON.parse(sessionStorage.getItem("vendorData")).tenant_id != 38 || ) {
        //     navigate(`/genefied/${getVendorName()}/`);

        // }
        fetchAllPointsSummaryFunc();
    }, [request, limit, offset]);

    useEffect(() => {
        if (borosilPointSummaryData && borosilPointSummaryData.body) {
            console.log("borosilPointSummaryData", borosilPointSummaryData);
            setData(borosilPointSummaryData.body.data);
            setTotalRows(borosilPointSummaryData.body.total_records);
        }

        if (borosilPointSUmmaryError) {
            if (borosilPointSUmmaryError.status != 500) {
                toast.error(`${borosilPointSUmmaryError?.data.message}`, {
                    id: "borosilPointSUmmaryError",
                });
            } else {
                toast.error("Something went wrong", {
                    id: "borosilPointSUmmaryError",
                });
            }
            console.log("borosilPointSUmmaryError ", borosilPointSUmmaryError);
        }
    }, [borosilPointSummaryData, borosilPointSUmmaryError]);

    useEffect(() => {
        if (borosilPointSummaryCsvData && borosilPointSummaryCsvData.body) {
            console.log(
                "borosilPointSummaryCsvData",
                borosilPointSummaryCsvData,
            );
            setCsvData(borosilPointSummaryCsvData?.body?.data);
            // setData(borosilPointSummaryCsvData.body.data);
            // setTotalRows(borosilPointSummaryCsvData.body.total_records)
        }

        if (borosilPointSUmmaryCsvError) {
            if (borosilPointSUmmaryCsvError.status != 500) {
                toast.error(`${borosilPointSUmmaryCsvError?.data.message}`, {
                    id: "borosilPointSUmmaryCsvError",
                });
            } else {
                toast.error("Something went wrong", {
                    id: "borosilPointSUmmaryCsvError",
                });
            }
            console.log(
                "borosilPointSUmmaryCsvError ",
                borosilPointSUmmaryCsvError,
            );
        }
    }, [borosilPointSummaryCsvData, borosilPointSUmmaryCsvError]);

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Mobile",
            selector: (row) => row.mobile,
            sortable: true,
            width: "120px",
        },
        {
            name: "User ID",
            selector: (row) => row.user_id,
            sortable: true,
            width: "150px",
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            width: "220px",
        },
        {
            name: (
                <div className="flex items-center gap-1 relative">
                    Points Earned
                    <div className="absolute -top-0.5 -right-6">
                        <div className="relative group">
                            <span className="text-blue-600 cursor-help select-none">
                                ⓘ
                            </span>
                            <div
                                className="
                        absolute top-full left-1/2 -translate-x-1/2 mt-1
                        z-[9999] w-max max-w-xs
                        px-3 py-2 text-xs text-white bg-black
                        opacity-0 group-hover:opacity-100
                        transition-opacity pointer-events-none
                        shadow-md
                      "
                                style={{ borderRadius: 0 }}
                            >
                                {getToolTipMessage("Points Earned")}
                            </div>
                        </div>
                    </div>
                </div>
            ),
            selector: (row) => row.Points_Earned,
            cell: (row) => <span>{formatter.format(row.Points_Earned)}</span>,
            sortable: true,
            width: "220px",
        },
        {
            name: (
                <div className="flex items-center gap-1 relative">
                    Extra Points
                    <div className="absolute -top-0.5 -right-6">
                        <div className="relative group">
                            <span className="text-blue-600 cursor-help select-none">
                                ⓘ
                            </span>
                            <div
                                className="
                        absolute top-full left-1/2 -translate-x-1/2 mt-1
                        z-[9999] w-max max-w-xs
                        px-3 py-2 text-xs text-white bg-black
                        opacity-0 group-hover:opacity-100
                        transition-opacity pointer-events-none
                        shadow-md
                      "
                                style={{ borderRadius: 0 }}
                            >
                                {getToolTipMessage("Extra Points")}
                            </div>
                        </div>
                    </div>
                </div>
            ),
            selector: (row) => row.Extra_Points,
            cell: (row) => <span>{formatter.format(row.Extra_Points)}</span>,
            sortable: true,
            width: "220px",
        },
        {
            name: (
                <div className="flex items-center gap-1 relative">
                    Total Points
                    <div className="absolute -top-0.5 -right-6">
                        <div className="relative group">
                            <span className="text-blue-600 cursor-help select-none">
                                ⓘ
                            </span>
                            <div
                                className="
                        absolute top-full left-1/2 -translate-x-1/2 mt-1
                        z-[9999] w-max max-w-xs
                        px-3 py-2 text-xs text-white bg-black
                        opacity-0 group-hover:opacity-100
                        transition-opacity pointer-events-none
                        shadow-md
                      "
                                style={{ borderRadius: 0 }}
                            >
                                {getToolTipMessage("Total Points")}
                            </div>
                        </div>
                    </div>
                </div>
            ),
            selector: (row) => row.Total_Points,
            cell: (row) => <span>{formatter.format(row.Total_Points)}</span>,
            sortable: true,
            width: "220px",
        },
        {
            name: "",
            cell: (row) => {
                return (
                    <div>
                        <button
                            onClick={() => {
                                setViewPointsSummaryToggle(true);
                                setPointsData(row);
                            }}
                            className="flex justify-center items-center rounded bg-green-900 px-2 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-green-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-green-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                        >
                            View
                        </button>
                    </div>
                );
            },
            sortable: true,
        },
    ];

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Users Point Summary
                        <LinksComponent />
                    </div>
                    <div className="p-3">
                        <div className="mb-2">
                            <CustomExport
                                fetchData={handlefetchAllPointsSummaryCsvFunc}
                                data={csvData}
                                defaultColumnExport={[
                                    "name",
                                    "mobile",
                                    "user_id",
                                    "Points_Earned",
                                    "Extra_Points",
                                    "Total_Points",
                                ]}
                                filename="userPointSummary"
                            />
                        </div>
                        <div className="p-3 w-full bg-white shadow rounded-lg">
                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                // title={"Product List"}
                                data={data}
                                loading={borosilPointSummaryIsLoading}
                                totalRows={totalRows}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                                paginationDefaultPage={currentPage}
                                paginationResetDefaultPage={paginationResetToggle}
                            >
                                <div className="border-b pb-3 border-gray-300 bg-gray-50 rounded-t-lg">
                                    <div className="flex  space-x-2 justify-end">
                                        <div className="w-52 h-10 ">
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    Mobile
                                                </label>
                                                <input
                                                    type="search"
                                                    id="default-search"
                                                    className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                    placeholder="Mobile..."
                                                    required
                                                    value={request.mobile}
                                                    onChange={(e) => {
                                                        const newValue =
                                                            e.target.value;
                                                        setRequest(
                                                            (prevState) => {
                                                                return {
                                                                    ...prevState,
                                                                    mobile: newValue,
                                                                };
                                                            },
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-52 h-10 ">
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    Name
                                                </label>
                                                <input
                                                    type="search"
                                                    id="default-search"
                                                    className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                    placeholder="Name..."
                                                    required
                                                    value={request.name}
                                                    onChange={(e) => {
                                                        const newValue =
                                                            e.target.value;
                                                        setRequest(
                                                            (prevState) => {
                                                                return {
                                                                    ...prevState,
                                                                    name: newValue,
                                                                };
                                                            },
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Start Month-Year */}
                                        <div className="w-52 h-10">
                                            <div className="relative searchin">
                                                <label className="block text-sm font-medium text-gray-900 mb-1">
                                                    Start Month
                                                </label>
                                                <input
                                                    type="month"
                                                    value={request.startDate}
                                                    onChange={(e) =>
                                                        setRequest((prev) => ({
                                                            ...prev,
                                                            startDate:
                                                                e.target.value,
                                                        }))
                                                    }
                                                    className="w-full px-2 py-1 border rounded"
                                                />
                                            </div>
                                        </div>

                                        {/* End Month-Year */}
                                        <div className="w-52 h-10">
                                            <div className="relative searchin">
                                                <label className="block text-sm font-medium text-gray-900 mb-1">
                                                    End Month
                                                </label>
                                                <input
                                                    type="month"
                                                    value={request.endDate}
                                                    onChange={(e) =>
                                                        setRequest((prev) => ({
                                                            ...prev,
                                                            endDate:
                                                                e.target.value,
                                                        }))
                                                    }
                                                    className="w-full px-2 py-1 border rounded"
                                                />
                                            </div>
                                        </div>

                                        <div className="flex flex-row  gap-2 h-10">
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    &nbsp;
                                                </label>
                                                <button
                                                    className="btn btn-outline-primary clear-both float-right  p-2"
                                                    onClick={() => {
                                                        fetchAllPointsSummaryFunc();
                                                    }}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    &nbsp;
                                                </label>
                                                <button
                                                    className="btn btn-outline-primary clear-both float-right p-2"
                                                    onClick={() => {
                                                        clearFilters();
                                                    }}
                                                >
                                                    Clear Filter
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </DataTableComponent>
                        </div>

                        {viewPointsSummaryToggle && (
                            <ModalComponent
                                size="xl"
                                show={viewPointsSummaryToggle}
                                setShow={setViewPointsSummaryToggle}
                            >
                                <div className="w-full">
                                    <div className="w-full p-4">
                                        <h2 className="text-lg font-semibold mb-4">
                                            Monthly Point Summary
                                        </h2>
                                        {Array.isArray(
                                            pointsData?.month_wise_data,
                                        ) &&
                                            pointsData?.month_wise_data.length >
                                            0 ? (
                                            <div className="overflow-x-auto">
                                                <table className="min-w-full table-auto border border-gray-300 text-sm">
                                                    <thead className="bg-gray-100">
                                                        <tr>
                                                            <th className="border px-4 py-2 text-left">
                                                                Month
                                                            </th>
                                                            <th className="border px-4 py-2 text-left">
                                                                Year
                                                            </th>
                                                            <th className="border px-4 py-2 text-left">
                                                                Points Earned
                                                            </th>
                                                            <th className="border px-4 py-2 text-left">
                                                                Points Reserved
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {pointsData?.month_wise_data.map(
                                                            (item, index) => (
                                                                <tr
                                                                    key={index}
                                                                    className="hover:bg-gray-50"
                                                                >
                                                                    <td className="border px-4 py-2">
                                                                        {
                                                                            item.month
                                                                        }
                                                                    </td>
                                                                    <td className="border px-4 py-2">
                                                                        {
                                                                            item.year
                                                                        }
                                                                    </td>
                                                                    <td className="border px-4 py-2">
                                                                        {
                                                                            item.points_earned
                                                                        }
                                                                    </td>
                                                                    <td className="border px-4 py-2">
                                                                        {
                                                                            item.points_reserved
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ),
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className="text-gray-500">
                                                No data available
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </ModalComponent>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default UsersPointSummary;



// import React, { useEffect, useState } from "react";
// import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
// import { useNavigate } from "react-router-dom";
// import { getVendorName } from "../../../utils/getVendorName";
// import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
// import { useFetchAllUserPointSummaryBorosilMutation } from "../../../features/tenant/Borosil/SalesBoosterHistoryBorosilApi";
// import toast from "react-hot-toast";
// import { formatter } from "../../../utils/numberFormatter";
// import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
// import CustomExport from "../../../components/CustomExport/CustomExport";

// function getToolTipMessage(type) {
//     const tooltipMap = new Map([
//         [
//             "Total Earned",
//             "This is the current total earned points of user including any extra points (dinner points not included).",
//         ],
//         [
//             "Total Balance",
//             "This is the current balance points (90 % of total earned points) of user.",
//         ],
//         [
//             "Total Reserved",
//             "This is the current reserved points (10 % of total earned points) of user.",
//         ],
//         [
//             "Total Extra Points",
//             "This is total sum of extra points of user (including dinner points).",
//         ],
//         ["Total Redeemed", "This is current redeemed points of user."],
//         ["Tds", "This is tds deducted points of user."],
//         [
//             "Available Reserved",
//             "This is available reserved points of user after deducting tds (if applicable).",
//         ],
//     ]);

//     return tooltipMap.get(type) || "";
// }

// const UsersPointSummary = () => {
//     const [
//         fetchBorosilPointsSummary,
//         {
//             data: borosilPointSummaryData,
//             isLoading: borosilPointSummaryIsLoading,
//             error: borosilPointSUmmaryError,
//         },
//     ] = useFetchAllUserPointSummaryBorosilMutation();

//     const [
//         fetchBorosilPointsSummaryCsv,
//         {
//             data: borosilPointSummaryCsvData,
//             isLoading: borosilPointSummaryCsvIsLoading,
//             error: borosilPointSUmmaryCsvError,
//         },
//     ] = useFetchAllUserPointSummaryBorosilMutation();

//     const navigate = useNavigate();

//     const [totalRows, setTotalRows] = useState(0);
//     const [data, setData] = useState([]);

//     const [viewPointsSummaryToggle, setViewPointsSummaryToggle] =
//         useState(false);
//     const [pointsData, setPointsData] = useState(null);

//     const [csvData, setCsvData] = useState(null);

//     const [limit, setLimit] = useState(10);
//     const [offset, setOffset] = useState(0);
//     const [prevPage, setPrevPage] = useState(0);

//     const initialRequest = {
//         mobile: "",
//         startDate: "",
//         endDate: "",
//         startMonth: null,
//         startYear: null,
//         endMonth: null,
//         endYear: null,
//         limit: limit,
//         offset: offset,
//     };

//     const [request, setRequest] = useState(initialRequest);

//     const clearFilters = () => {
//         setRequest(initialRequest);
//     };

//     const fetchAllPointsSummaryFunc = () => {
//         const { startDate, endDate, ...rest } = request;

//         let updatedRequest = { ...rest };

//         if (startDate) {
//             const [year, month] = startDate.split("-");
//             updatedRequest.startYear = year;
//             updatedRequest.startMonth = month;
//         }

//         if (endDate) {
//             const [year, month] = endDate.split("-");
//             updatedRequest.endYear = year;
//             updatedRequest.endMonth = month;
//         }

//         const queryParams = new URLSearchParams(updatedRequest).toString();

//         fetchBorosilPointsSummary({
//             token: sessionStorage.getItem("access_token"),
//             tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
//                 .tenant_id,
//             queryParams: queryParams,
//         });
//     };

//     const handlefetchAllPointsSummaryCsvFunc = () => {
//         const { startDate, endDate, ...rest } = request;

//         let updatedRequest = { ...rest };

//         if (startDate) {
//             const [year, month] = startDate.split("-");
//             updatedRequest.startYear = year;
//             updatedRequest.startMonth = month;
//         }

//         if (endDate) {
//             const [year, month] = endDate.split("-");
//             updatedRequest.endYear = year;
//             updatedRequest.endMonth = month;
//         }

//         updatedRequest.limit = 10000;
//         updatedRequest.offset = 0;

//         const queryParams = new URLSearchParams(updatedRequest).toString();

//         fetchBorosilPointsSummaryCsv({
//             token: sessionStorage.getItem("access_token"),
//             tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
//                 .tenant_id,
//             queryParams: queryParams,
//         });
//     };

//     useEffect(() => {
//         // if (JSON.parse(sessionStorage.getItem("vendorData")).tenant_id != 38 || ) {
//         //     navigate(`/genefied/${getVendorName()}/`);

//         // }
//         fetchAllPointsSummaryFunc();
//     }, [request, limit, offset]);

//     useEffect(() => {
//         if (borosilPointSummaryData && borosilPointSummaryData.body) {
//             console.log("borosilPointSummaryData", borosilPointSummaryData);
//             setData(borosilPointSummaryData.body.data);
//             setTotalRows(borosilPointSummaryData.body.total_records);
//         }

//         if (borosilPointSUmmaryError) {
//             if (borosilPointSUmmaryError.status != 500) {
//                 toast.error(`${borosilPointSUmmaryError?.data.message}`, {
//                     id: "borosilPointSUmmaryError",
//                 });
//             } else {
//                 toast.error("Something went wrong", {
//                     id: "borosilPointSUmmaryError",
//                 });
//             }
//             console.log("borosilPointSUmmaryError ", borosilPointSUmmaryError);
//         }
//     }, [borosilPointSummaryData, borosilPointSUmmaryError]);

//     useEffect(() => {
//         if (borosilPointSummaryCsvData && borosilPointSummaryCsvData.body) {
//             console.log(
//                 "borosilPointSummaryCsvData",
//                 borosilPointSummaryCsvData,
//             );
//             setCsvData(borosilPointSummaryCsvData?.body?.data);
//             // setData(borosilPointSummaryCsvData.body.data);
//             // setTotalRows(borosilPointSummaryCsvData.body.total_records)
//         }

//         if (borosilPointSUmmaryCsvError) {
//             if (borosilPointSUmmaryCsvError.status != 500) {
//                 toast.error(`${borosilPointSUmmaryCsvError?.data.message}`, {
//                     id: "borosilPointSUmmaryCsvError",
//                 });
//             } else {
//                 toast.error("Something went wrong", {
//                     id: "borosilPointSUmmaryCsvError",
//                 });
//             }
//             console.log(
//                 "borosilPointSUmmaryCsvError ",
//                 borosilPointSUmmaryCsvError,
//             );
//         }
//     }, [borosilPointSummaryCsvData, borosilPointSUmmaryCsvError]);

//     const columns = [
//         {
//             name: "SNo",
//             cell: (row, idx) => offset + Number(idx + 1),
//             sortable: true,
//             width: "80px",
//         },
//         {
//             name: "Mobile",
//             selector: (row) => row.mobile,
//             sortable: true,
//             width: "120px",
//         },
//         {
//             name: "User ID",
//             selector: (row) => row.user_id,
//             sortable: true,
//             width: "150px",
//         },
//         {
//             name: "Name",
//             selector: (row) => row.name,
//             sortable: true,
//             width: "220px",
//         },
//         {
//             name: (
//                 <div className="flex items-center gap-1 relative">
//                     Total Earned
//                     <div className="absolute -top-0.5 -right-6">
//                         <div className="relative group">
//                             <span className="text-blue-600 cursor-help select-none">
//                                 ⓘ
//                             </span>
//                             <div
//                                 className="
//                         absolute top-full left-1/2 -translate-x-1/2 mt-1
//                         z-[9999] w-max max-w-xs
//                         px-3 py-2 text-xs text-white bg-black
//                         opacity-0 group-hover:opacity-100
//                         transition-opacity pointer-events-none
//                         shadow-md
//                       "
//                                 style={{ borderRadius: 0 }}
//                             >
//                                 {getToolTipMessage("Total Earned")}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             ),
//             selector: (row) => row.total_earned,
//             cell: (row) => <span>{formatter.format(row.total_earned)}</span>,
//             sortable: true,
//             width: "220px",
//         },
//         {
//             name: (
//                 <div className="flex items-center gap-1 relative">
//                     Total Balance
//                     <div className="absolute -top-0.5 -right-6">
//                         <div className="relative group">
//                             <span className="text-blue-600 cursor-help select-none">
//                                 ⓘ
//                             </span>
//                             <div
//                                 className="
//                         absolute top-full left-1/2 -translate-x-1/2 mt-1
//                         z-[9999] w-max max-w-xs
//                         px-3 py-2 text-xs text-white bg-black
//                         opacity-0 group-hover:opacity-100
//                         transition-opacity pointer-events-none
//                         shadow-md
//                       "
//                                 style={{ borderRadius: 0 }}
//                             >
//                                 {getToolTipMessage("Total Balance")}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             ),
//             selector: (row) => row.total_balance,
//             cell: (row) => <span>{formatter.format(row.total_balance)}</span>,
//             sortable: true,
//             width: "220px",
//         },

//         {
//             name: (
//                 <div className="flex items-center gap-1 relative">
//                     Total Reserved
//                     <div className="absolute -top-0.5 -right-6">
//                         <div className="relative group">
//                             <span className="text-blue-600 cursor-help select-none">
//                                 ⓘ
//                             </span>
//                             <div
//                                 className="
//                         absolute top-full left-1/2 -translate-x-1/2 mt-1
//                         z-[9999] w-max max-w-xs
//                         px-3 py-2 text-xs text-white bg-black
//                         opacity-0 group-hover:opacity-100
//                         transition-opacity pointer-events-none
//                         shadow-md
//                       "
//                                 style={{ borderRadius: 0 }}
//                             >
//                                 {getToolTipMessage("Total Reserved")}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             ),
//             selector: (row) => row.total_reserved,
//             cell: (row) => <span>{formatter.format(row.total_reserved)}</span>,
//             sortable: true,
//             width: "220px",
//         },
//         {
//             name: (
//                 <div className="flex items-center gap-1 relative">
//                     Total Extra Points
//                     <div className="absolute -top-0.5 -right-6">
//                         <div className="relative group">
//                             <span className="text-blue-600 cursor-help select-none">
//                                 ⓘ
//                             </span>
//                             <div
//                                 className="
//                         absolute top-full left-1/2 -translate-x-1/2 mt-1
//                         z-[9999] w-max max-w-xs
//                         px-3 py-2 text-xs text-white bg-black
//                         opacity-0 group-hover:opacity-100
//                         transition-opacity pointer-events-none
//                         shadow-md
//                       "
//                                 style={{ borderRadius: 0 }}
//                             >
//                                 {getToolTipMessage("Total Extra Points")}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             ),
//             selector: (row) => row.extra_points,
//             cell: (row) => <span>{formatter.format(row.extra_points)}</span>,
//             sortable: true,
//             width: "220px",
//         },

//         {
//             name: (
//                 <div className="flex items-center gap-1 relative">
//                     Total Redeemed
//                     <div className="absolute -top-0.5 -right-6">
//                         <div className="relative group">
//                             <span className="text-blue-600 cursor-help select-none">
//                                 ⓘ
//                             </span>
//                             <div
//                                 className="
//                         absolute top-full left-1/2 -translate-x-1/2 mt-1
//                         z-[9999] w-max max-w-xs
//                         px-3 py-2 text-xs text-white bg-black
//                         opacity-0 group-hover:opacity-100
//                         transition-opacity pointer-events-none
//                         shadow-md
//                       "
//                                 style={{ borderRadius: 0 }}
//                             >
//                                 {getToolTipMessage("Total Redeemed")}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             ),
//             selector: (row) => row.total_redeemed,
//             cell: (row) => <span>{formatter.format(row.total_redeemed)}</span>,
//             sortable: true,
//             width: "220px",
//         },

//         {
//             name: (
//                 <div className="flex items-center gap-1 relative">
//                     Tds
//                     <div className="absolute -top-0.5 -right-6">
//                         <div className="relative group">
//                             <span className="text-blue-600 cursor-help select-none">
//                                 ⓘ
//                             </span>
//                             <div
//                                 className="
//                         absolute top-full left-1/2 -translate-x-1/2 mt-1
//                         z-[9999] w-max max-w-xs
//                         px-3 py-2 text-xs text-white bg-black
//                         opacity-0 group-hover:opacity-100
//                         transition-opacity pointer-events-none
//                         shadow-md
//                       "
//                                 style={{ borderRadius: 0 }}
//                             >
//                                 {getToolTipMessage("Tds")}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             ),
//             selector: (row) => formatter.format(row.total_redeemed * 0.1),
//             cell: (row) => {
//                 const isHigh = row.total_redeemed >= 20000;
//                 const tdsValue = formatter.format(row.total_redeemed * 0.1);
//                 return (
//                     <span
//                         className={`text-sm p-1 rounded-sm  ${isHigh
//                             ? " text-white font-bold bg-red-600"
//                             : " text-black "
//                             }`}
//                     >
//                         {tdsValue}
//                     </span>
//                 );
//             },
//             sortable: true,
//             width: "220px",
//         },


//         {
//             name: (
//                 <div className="flex items-center gap-1 relative">
//                     Available Reserved
//                     <div className="absolute -top-0.5 -right-6">
//                         <div className="relative group">
//                             <span className="text-blue-600 cursor-help select-none">
//                                 ⓘ
//                             </span>
//                             <div
//                                 className="
//                         absolute top-full left-1/2 -translate-x-1/2 mt-1
//                         z-[9999] w-max max-w-xs
//                         px-3 py-2 text-xs text-white bg-black
//                         opacity-0 group-hover:opacity-100
//                         transition-opacity pointer-events-none
//                         shadow-md
//                       "
//                                 style={{ borderRadius: 0 }}
//                             >
//                                 {getToolTipMessage("Available Reserved")}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             ),
//             selector: (row) =>
//                 formatter.format(row.total_reserved - row.total_redeemed * 0.1),
//             cell: (row) =>
//                 formatter.format(row.total_reserved - row.total_redeemed * 0.1),
//             sortable: true,
//             width: "220px",
//         },

//         {
//             name: "",
//             cell: (row) => {
//                 return (
//                     <div>
//                         <button
//                             onClick={() => {
//                                 setViewPointsSummaryToggle(true);
//                                 setPointsData(row);
//                             }}
//                             className="flex justify-center items-center rounded bg-green-900 px-2 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-green-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-green-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
//                         >
//                             View
//                         </button>
//                     </div>
//                 );
//             },
//             sortable: true,
//         },
//     ];

//     const handlePageChange = (pageNumber) => {
//         const newOffset = (pageNumber - 1) * limit;
//         setOffset(newOffset);
//         setRequest({ ...request, offset: newOffset });
//         setPrevPage(pageNumber - 1);
//     };

//     const handlePerRowsChange = (newPerPage, page) => {
//         setRequest({ ...request, limit: newPerPage });
//         setLimit(newPerPage);
//     };

//     return (
//         <>
//             <div className="flex w-full bg-gray-200 h-full justify-center">
//                 <div className="w-full">
//                     <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
//                         Users Point Summary
//                         <LinksComponent />
//                     </div>
//                     <div className="p-3">
//                         <div className="mb-2">
//                             <CustomExport
//                                 fetchData={handlefetchAllPointsSummaryCsvFunc}
//                                 data={csvData}
//                                 defaultColumnExport={[
//                                     "name",
//                                     "mobile",
//                                     "user_id",

//                                     "total_earned",
//                                     "total_balance",
//                                     "total_reserved",
//                                     "extra_points",
//                                     "total_redeemed",
//                                 ]}
//                                 filename="userPointSummary"
//                             />
//                         </div>
//                         <div className="p-3 w-full bg-white shadow rounded-lg">
//                             <DataTableComponent
//                                 keyField={(row) => row.SNo}
//                                 columns={columns}
//                                 // title={"Product List"}
//                                 data={data}
//                                 loading={borosilPointSummaryIsLoading}
//                                 totalRows={totalRows}
//                                 handlePerRowsChange={handlePerRowsChange}
//                                 handlePageChange={handlePageChange}
//                             >
//                                 <div className="border-b pb-3 border-gray-300 bg-gray-50 rounded-t-lg">
//                                     <div className="flex  space-x-2 justify-end">
//                                         <div className="w-52 h-10 ">
//                                             <div className="relative searchin">
//                                                 <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
//                                                     Mobile
//                                                 </label>
//                                                 <input
//                                                     type="search"
//                                                     id="default-search"
//                                                     className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
//                                                     placeholder="Mobile..."
//                                                     required
//                                                     value={request.mobile}
//                                                     onChange={(e) => {
//                                                         const newValue =
//                                                             e.target.value;
//                                                         setRequest(
//                                                             (prevState) => {
//                                                                 return {
//                                                                     ...prevState,
//                                                                     mobile: newValue,
//                                                                 };
//                                                             },
//                                                         );
//                                                     }}
//                                                 />
//                                             </div>
//                                         </div>
//                                         <div className="w-52 h-10 ">
//                                             <div className="relative searchin">
//                                                 <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
//                                                     Name
//                                                 </label>
//                                                 <input
//                                                     type="search"
//                                                     id="default-search"
//                                                     className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
//                                                     placeholder="Name..."
//                                                     required
//                                                     value={request.name}
//                                                     onChange={(e) => {
//                                                         const newValue =
//                                                             e.target.value;
//                                                         setRequest(
//                                                             (prevState) => {
//                                                                 return {
//                                                                     ...prevState,
//                                                                     name: newValue,
//                                                                 };
//                                                             },
//                                                         );
//                                                     }}
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* Start Month-Year */}
//                                         <div className="w-52 h-10">
//                                             <div className="relative searchin">
//                                                 <label className="block text-sm font-medium text-gray-900 mb-1">
//                                                     Start Month
//                                                 </label>
//                                                 <input
//                                                     type="month"
//                                                     value={request.startDate}
//                                                     onChange={(e) =>
//                                                         setRequest((prev) => ({
//                                                             ...prev,
//                                                             startDate:
//                                                                 e.target.value,
//                                                         }))
//                                                     }
//                                                     className="w-full px-2 py-1 border rounded"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* End Month-Year */}
//                                         <div className="w-52 h-10">
//                                             <div className="relative searchin">
//                                                 <label className="block text-sm font-medium text-gray-900 mb-1">
//                                                     End Month
//                                                 </label>
//                                                 <input
//                                                     type="month"
//                                                     value={request.endDate}
//                                                     onChange={(e) =>
//                                                         setRequest((prev) => ({
//                                                             ...prev,
//                                                             endDate:
//                                                                 e.target.value,
//                                                         }))
//                                                     }
//                                                     className="w-full px-2 py-1 border rounded"
//                                                 />
//                                             </div>
//                                         </div>

//                                         <div className="flex flex-row  gap-2 h-10">
//                                             <div className="relative searchin">
//                                                 <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
//                                                     &nbsp;
//                                                 </label>
//                                                 <button
//                                                     className="btn btn-outline-primary clear-both float-right  p-2"
//                                                     onClick={() => {
//                                                         fetchAllPointsSummaryFunc();
//                                                     }}
//                                                 >
//                                                     Search
//                                                 </button>
//                                             </div>
//                                             <div className="relative searchin">
//                                                 <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
//                                                     &nbsp;
//                                                 </label>
//                                                 <button
//                                                     className="btn btn-outline-primary clear-both float-right p-2"
//                                                     onClick={() => {
//                                                         clearFilters();
//                                                     }}
//                                                 >
//                                                     Clear Filter
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </DataTableComponent>
//                         </div>

//                         {viewPointsSummaryToggle && (
//                             <ModalComponent
//                                 size="xl"
//                                 show={viewPointsSummaryToggle}
//                                 setShow={setViewPointsSummaryToggle}
//                             >
//                                 <div className="w-full">
//                                     <div className="w-full p-4">
//                                         <h2 className="text-lg font-semibold mb-4">
//                                             Monthly Point Summary
//                                         </h2>
//                                         {Array.isArray(
//                                             pointsData?.month_wise_data,
//                                         ) &&
//                                             pointsData?.month_wise_data.length >
//                                             0 ? (
//                                             <div className="overflow-x-auto">
//                                                 <table className="min-w-full table-auto border border-gray-300 text-sm">
//                                                     <thead className="bg-gray-100">
//                                                         <tr>
//                                                             <th className="border px-4 py-2 text-left">
//                                                                 Month
//                                                             </th>
//                                                             <th className="border px-4 py-2 text-left">
//                                                                 Year
//                                                             </th>
//                                                             <th className="border px-4 py-2 text-left">
//                                                                 Points Earned
//                                                             </th>
//                                                             <th className="border px-4 py-2 text-left">
//                                                                 Points Reserved
//                                                             </th>
//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>
//                                                         {pointsData?.month_wise_data.map(
//                                                             (item, index) => (
//                                                                 <tr
//                                                                     key={index}
//                                                                     className="hover:bg-gray-50"
//                                                                 >
//                                                                     <td className="border px-4 py-2">
//                                                                         {
//                                                                             item.month
//                                                                         }
//                                                                     </td>
//                                                                     <td className="border px-4 py-2">
//                                                                         {
//                                                                             item.year
//                                                                         }
//                                                                     </td>
//                                                                     <td className="border px-4 py-2">
//                                                                         {
//                                                                             item.points_earned
//                                                                         }
//                                                                     </td>
//                                                                     <td className="border px-4 py-2">
//                                                                         {
//                                                                             item.points_reserved
//                                                                         }
//                                                                     </td>
//                                                                 </tr>
//                                                             ),
//                                                         )}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                         ) : (
//                                             <div className="text-gray-500">
//                                                 No data available
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </ModalComponent>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default UsersPointSummary;
